import { isEmpty } from "lodash-es";

export const required = (value) => {
  return [undefined, null, ""].includes(value) || value.toString().trim() === ""
    ? "Required"
    : undefined;
};

export const requiredNumber = (value) => {
  return [undefined, null, "", 0].includes(value) ? "Required" : undefined;
};

export const requiredList = (value) => {
  return isEmpty(value) ? "Required" : undefined;
};

export const requiredWithErrorCode = (value, errorCode) => {
  return [undefined, null, ""].includes(value)
    ? `${errorCode} : Required`
    : undefined;
};
